'use client';

import BookingSummary from '@/components/booking-summary/summary';
import FareSummary from '@/components/fare-summary/fare-summary';
import PaymentTypes from '@/components/payment-type/page';
import { Button } from '@/components/ui/button';
import Link from '@/lib/app-link';
import React from 'react';

function Payment() {
  return (
    <div className="h-full bg-tertiary">
      <div className="h-40 w-full bg-primary"></div>
      <div className="z-[2] -mt-28 px-12 pb-20">
        <h2 className="mb-7 pl-8 font-semibold text-white">Payment</h2>
        <div className="flex flex-row gap-8">
          <div className="basis-[75%] rounded-xl bg-white p-8">
            <h3 className="my-6 font-semibold">Payment Options</h3>

            <PaymentTypes />
          </div>
          <div className="flex basis-[25%] flex-col gap-5">
            <div>{/* <FareSummary summary={undefined} href={""} /> */}</div>
            <div>
              <BookingSummary />
              <Link href={'/confirm'}>
                <Button>Confirm</Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Payment;
